import Vue from 'vue'
import Router from '../router'

// Error display
const sweetAlert = message => {
	Vue.prototype.$swal.fire({
		icon: 'error',
		title: 'Error...',
		text: message
	})
}

// User login
const login = credentials => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/login',
			auth: credentials
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get Branch info such as name and phone number
const branchInfo = () => {
	return Vue.prototype
		.$axios({
			method: 'get',
			url: '/bd/info'
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Create new order
const orderCreate = (backdate = null) => {
	var data = {
		payment_method: [1]
	}

	if (backdate !== null) {
		data.backdate = true
		data.createdAt = backdate
		data.updatedAt = backdate
	}

	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order/create',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get product details
const productDetail = data => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/detail',
			data: data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Update product
const productUpdate = data => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/update',
			data: data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Update Product in Order
const orderUpdate = ({ data }) => {
	// console.log(data);

	return Vue.prototype
		.$axios({
			method: 'patch',
			url: '/bd/order/update',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get Order Details
const orderDetails = data => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order/detail',
			data: {
				id: data,
				populate_order: ['salesperson', 'coupons.brand']
			}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Search for sales person name
const getSalesperson = data => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/staff/list',
			data: {
				username: data,
				roles: ['salesperson']
			}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get staff list
const getStaffs = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/staff/list',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get staff profile
const getStaffProfile = data => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/staff/profile',
			data: {
				id: data
			}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get list of orders
const orderList = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order/list',
			data
		})
		.catch(err => {
			if (err.response.status == 401) {
				Router.push('/logout')
			}

			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get list of brands
const getBrandList = () => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/brand/list',
			data: {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
		})
		.catch(err => {
			if (err.response.status == 401) {
				Router.push('/logout')
			}

			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get list of chemicals
const getChemicalList = () => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/chemical/list'
		})
		.catch(err => {
			if (err.response.status == 401) {
				Router.push('/logout')
			}

			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Search product
const searchProduct = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/list',
			data
		})
		.catch(err => {
			if (err.response.status == 401) {
				Router.push('/logout')
			}

			sweetAlert(err.response.data.message)
			// if (err.response.status == 401 && err.response.statusText == 'Unauthorized') {
			// }
		})
}

// Get product details
const getProductDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/detail',
			data
		})
		.catch(err => {
			if (err.response.status == 401) {
				Router.push('/logout')
			}

			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get product details
const getPromo = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/promotion/list',
			data
		})
		.catch(err => {
			if (err.response.status == 401) {
				Router.push('/logout')
			}

			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get own profile
const getOwnProfile = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'get',
			url: '/bd/staff/profile-self',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Restore Staff
const restoreStaff = () => {
	return Vue.prototype
		.$axios({
			method: 'put',
			url: '/bd/staff/restore',
			data: {}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Restore Products
const restoreProducts = () => {
	return Vue.prototype
		.$axios({
			method: 'put',
			url: '/bd/product/restore',
			data: {}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Restore Brand
const restoreBrand = () => {
	return Vue.prototype
		.$axios({
			method: 'put',
			url: '/bd/brand/restore',
			data: {}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Restore Category
const restoreCategory = () => {
	return Vue.prototype
		.$axios({
			method: 'put',
			url: '/bd/category/restore',
			data: {}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Restore Category
const restorePromotion = () => {
	return Vue.prototype
		.$axios({
			method: 'put',
			url: '/bd/promotion/restore',
			data: {}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Restore Orders
const restoreOrder = () => {
	return Vue.prototype
		.$axios({
			method: 'put',
			url: '/bd/order/restore',
			data: {}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Upload orders to cloud
const backupOrder = () => {
	return Vue.prototype
		.$axios({
			method: 'put',
			url: '/bd/order/backup',
			data: {}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Sync
const syncNow = () => {
	return Vue.prototype
		.$axios({
			method: 'patch',
			url: '/bd/sync',
			data: {}
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Sync
const updateForceProduct = data => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/force-update',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get members
const getMember = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/list',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Search members
const searchMember = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/search',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get members
const createMember = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/create',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get rewards
const getRewards = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/reward/list',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Get reward History
const getRewardHistory = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/reward/history/list',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

// Save rewards
const rewardCheckout = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/reward/checkout',
			data
		})
		.catch(err => {
			sweetAlert(err.response.data.message)
			// console.log(err.response);
		})
}

export default {
	sweetAlert: sweetAlert,
	login: login,
	branchInfo: branchInfo,
	productDetail: productDetail,
	orderCreate: orderCreate,
	orderDetails: orderDetails,
	getSalesperson: getSalesperson,
	getStaffProfile: getStaffProfile,
	getStaffs: getStaffs,
	orderList: orderList,
	orderUpdate: orderUpdate,
	getBrandList: getBrandList,
	getChemicalList: getChemicalList,
	searchProduct: searchProduct,
	getProductDetail: getProductDetail,
	getPromo: getPromo,
	productUpdate: productUpdate,
	getOwnProfile: getOwnProfile,
	restoreStaff: restoreStaff,
	restoreProducts: restoreProducts,
	restoreBrand: restoreBrand,
	restoreCategory: restoreCategory,
	restorePromotion: restorePromotion,
	restoreOrder: restoreOrder,
	backupOrder: backupOrder,
	syncNow: syncNow,
	updateForceProduct: updateForceProduct,
	getMember: getMember,
	searchMember: searchMember,
	createMember: createMember,
	getRewards: getRewards,
	getRewardHistory: getRewardHistory,
	rewardCheckout: rewardCheckout
}
